import { observer } from "mobx-react";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { t } from "../../i18n/util";
import { generalStore } from "../../stores/GeneralStore";
import { THEME, isDal } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { HrBotBackButton, HrBotButton, HrBotOutlinedButton } from "./Primitives";
import { AAA_PRIVACY_LINK, DAL_PRIVACY_LINK } from "../../config";

type Props = {
    handleOpen: () => void;
};

// TODO do not directly pass handleSomething handlers but proper on-handler instead
export const CookieBanner = observer(({ handleOpen }: Props) => {
    const handleSubmit = (googleAnalytics: boolean) => {
        generalStore.googleAnalyticsCookies = googleAnalytics;
        generalStore.acceptedCookies = true;
    };

    const isMobile = useMobileMediaQuery();

    const FunctionalCookiesButton = isDal() ? HrBotBackButton : HrBotOutlinedButton;
    const CookieSettingsButton = isDal() ? HrBotButton : HrBotOutlinedButton;

    return (
        <div
            style={{
                position: "fixed",
                bottom: 0,
                height: isMobile ? 150 : 135,
                zIndex: 12,
                width: "100vw",
                padding: "10px 20px",
                display: "flex",
                backgroundColor: THEME.customColors.darkPrimary,
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: isMobile ? "column" : "row"
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
                <p className={isMobile ? "caption" : ""}>
                    <FormattedMessage
                        id="screen.cookieBanner.text"
                        values={{
                            a: (chunks: Array<React.ReactElement | string>) => (
                                <a
                                    href={THEME.THEME_NAME === "aaa" ? AAA_PRIVACY_LINK : DAL_PRIVACY_LINK}
                                    style={{ color: THEME.customColors.primary, textDecoration: "none" }}
                                >
                                    {chunks}
                                </a>
                            )
                        }}
                    />
                </p>
                {!isMobile && (
                    <>
                        <CookieSettingsButton
                            label={t("screen.cookieBanner.settings")}
                            style={{ alignSelf: "unset" }}
                            onClick={handleOpen}
                        />
                    </>
                )}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
                <FunctionalCookiesButton
                    label={isMobile ? t("screen.cookieBanner.settings") : t("screen.cookieBanner.functionalCookies")}
                    onClick={isMobile ? handleOpen : () => handleSubmit(false)}
                    small={isMobile}
                />
                <HrBotButton
                    label={t("screen.cookieBanner.acceptAll")}
                    onClick={() => handleSubmit(true)}
                    small={isMobile}
                />
            </div>
        </div>
    );
});
